import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Plans from "./plans";
import EmbeddedCheckoutComponent from "./EmbeddedCheckout";

const SelectPlan = () => {
  const navigate = useNavigate();
  const savedPlanId = localStorage.getItem("selectedPlan");
  const [selectedPlan, setSelectedPlan] = useState(savedPlanId || null);
  const [errorMessage, setErrorMessage] = useState("");
  const [showCheckout, setShowCheckout] = useState(false);

  const OWNER_PLANS = [
    {
      idPlan: "particular-basico",
      priceId:
        import.meta.env.VITE_PUBLIC_INDIVIDUAL ||
        "price_1SnSdaHGBw2VKdDPGG3FKZr5",
    },
    {
      idPlan: "particular-destacado",
      priceId:
        import.meta.env.VITE_PUBLIC_INDIVIDUAL_THREE_MONTHS_FEATURED ||
        "price_1SD8s7HGBw2VKdDP7zDW3lqZ",
    },
    {
      idPlan: "particular-estandar",
      priceId:
        import.meta.env.VITE_PUBLIC_INDIVIDUAL_THREE_MONTHS ||
        "price_1SD8srHGBw2VKdDPj6z2Q4Dh",
    },
  ];

  const getSelectedPriceId = () => {
    const plan = OWNER_PLANS.find((p) => p.idPlan === selectedPlan);
    return plan ? plan.priceId : null;
  };

  const handleSubmit = async () => {
    if (!selectedPlan) {
      setErrorMessage("Por favor, selecciona un plan antes de continuar.");
      return;
    }

    setErrorMessage("");
    setShowCheckout(true);
  };

  const handleBackToPlans = () => {
    setShowCheckout(false);
  };

  useEffect(() => {
    if (!localStorage.getItem("CYTpropertyUuid")) {
      navigate("/unirse/ubicacion-precio");
    }
  }, [navigate]);

  useEffect(() => {
    if (selectedPlan) {
      localStorage.setItem("selectedPlan", selectedPlan);
      setErrorMessage("");
    }
  }, [selectedPlan]);

  return (
    <div className="sticky bottom-0 col-span-2 w-full bg-white md:p-4 md:pb-10 h-full md:block">
      {showCheckout ? (
        <div className="w-full flex items-center justify-center">
          <EmbeddedCheckoutComponent
            priceId={getSelectedPriceId()}
            onBack={handleBackToPlans}
          />
        </div>
      ) : (
        <>
          <div className="w-full flex items-center justify-center">
            <h1 className="text-lg font-semibold w-full max-w-2xl">
              Ya casi terminas, confirma tu plan:
            </h1>
          </div>

          <Plans selectedPlan={selectedPlan} onSelectPlan={setSelectedPlan} />

          {errorMessage && (
            <div className="w-full flex items-center justify-center mt-4">
              <div className="max-w-2xl w-full">
                <div
                  className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded relative"
                  role="alert"
                >
                  <span className="block sm:inline">{errorMessage}</span>
                </div>
              </div>
            </div>
          )}

          <div className="w-full flex items-center justify-center">
            <div className="grid grid-cols-2 max-w-2xl w-full md:mt-6">
              <a href={"/unirse/descripcion"} className="self-center underline">
                Regresar
              </a>
              <button
                type="button"
                onClick={handleSubmit}
                disabled={!selectedPlan}
                className={`group relative flex w-full justify-center whitespace-nowrap rounded-md border border-transparent py-2 px-4 md:text-lg font-medium text-white focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2 ${
                  !selectedPlan
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-black hover:bg-gray-800"
                }`}
              >
                Contratar y publicar
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SelectPlan;
